<span class="font-bold text-2xl mb-5" *ngIf="showTitle" translate>
    lingueopro.job.form.title
</span>

<div class="w-full" translate>
    lingueopro.job.form.description
</div>

<div class="grid sm:grid-cols-3 gap-8 w-full mt-8" [formGroup]="businessForm">
    <mat-radio-group class="invisible absolute w-0 h-0 pointer-events-none" [formControlName]="'job_situation'"
        #jobRadioGroup="matRadioGroup">
        <ng-container *ngFor="let situation of job_situation_options; trackBy: trackByFn">
            <mat-radio-button [value]="situation.value"></mat-radio-button>
        </ng-container>
    </mat-radio-group>

    <ng-container *ngFor="let situation of job_situation_options; trackBy: trackByFn">
        <div class="relative flex flex-col items-start justify-start p-6 rounded-md shadow cursor-pointer bg-card"
            [ngClass]="{'ring ring-inset ring-primary':  businessForm.controls.job_situation.value === situation.value}"
            (click)="
                    businessForm.controls.job_situation.setValue(situation.value);">
            <div class="font-medium" translate>{{ situation.label }}</div>
            <div class="flex-auto"></div>
        </div>
    </ng-container>

    <mat-error
        *ngIf="businessForm.controls.job_situation.touched && businessForm.controls.job_situation.hasError('required')">
        Ce champs est requis
    </mat-error>
</div>

<ng-container
    *ngIf="businessForm.controls.job_situation.value && businessForm.controls.job_situation.value!=='retired' && businessForm.controls.job_situation.value!=='student'">
    <div *ngIf="jobRadioGroup.value=='unemployed'" class="mt-5 font-bold" translate>
        lingueopro.job.form.unemployedJob
    </div>
    <div *ngIf="jobRadioGroup.value=='employed'" class="mt-5 font-bold" translate>
        lingueopro.job.form.employedJob
    </div>
    <div class="grid grid-cols-1 gap-4 mt-5">

        <div class="job-field autocomplete flex items-center" *ngIf="jobs && !showJobSuggestionField && !suggestedJob">
            <mat-icon class="icon-size-5 mr-2" matPrefix>search</mat-icon>
            <input #jobInput class="searchInput" type="text" matInput placeholder="Recherchez un métier"
                [formControl]="searchJobControl" [matAutocomplete]="autoJob"
                #jobAutocompleteTrigger="matAutocompleteTrigger"
                (blur)="onJobInputBlur()" />


            <mat-autocomplete #autoJob="matAutocomplete" [displayWith]="displayJob">
                <mat-option class="capitalize" *ngFor="let job of jobs" [value]="job"
                    (onSelectionChange)="selectJob(job, $event)">
                    {{ job.name }}
                </mat-option>
                <hr *ngIf="shouldInviteJobSuggestion() && !showJobSuggestionField" class="divider border-2 my-2">
                <mat-option class="bg-gray-200"
                    *ngIf="shouldInviteJobSuggestion() && !showJobSuggestionField && (searchJobControl.value?.name || searchJobControl.value)"
                    (onSelectionChange)="onJobSuggestOptionSelection($event); closeJobAutocomplete()">
                    <span class="text-blue-600">
                        <span translate>lingueopro.job.form.suggestButton </span> <span class="font-semibold"> {{ (searchJobControl.value?.name || searchJobControl.value
                            || '') }}</span>
                    </span>
                </mat-option>
            </mat-autocomplete>
        </div>

        <mat-error *ngIf="searchJobControl.touched && searchJobControl.hasError('required')" translate>
            lingueopro.job.form.errorRequired
        </mat-error>

        <div class="flex flex-col mt-2" *ngIf="suggestedJobControl.value || user.job_suggested">
            <div class="text-lg">
            <span translate>lingueopro.job.form.yourSuggestion.job </span> <span class="font-semibold"> {{
                suggestedJobControl.value || user.job_suggested }}</span>
            </div>
        </div>
    </div>
    <!-- Question sur le secteur -->
    <div *ngIf="jobRadioGroup.value=='unemployed'" class="font-bold mt-5" translate>
        lingueopro.job.form.unemployedSector
    </div>
    <div *ngIf="jobRadioGroup.value=='employed'" class="font-bold mt-5" translate>
        lingueopro.job.form.employedSector
    </div>
    <div class="grid grid-cols-1 gap-4 mt-5">
        <div class="job-field autocomplete flex items-center"
            *ngIf="businesses && !showBusinessSuggestionField && !suggestedBusiness">
            <mat-icon class="icon-size-5 mr-2" matPrefix>search</mat-icon>
            <input #businessInput class="searchInput" type="text" matInput placeholder="Recherchez un secteur"
                [formControl]="searchBusinessControl" [matAutocomplete]="autoBusiness"
                #businessAutocompleteTrigger="matAutocompleteTrigger"
                (blur)="onBusinessInputBlur()" />

            <mat-autocomplete #autoBusiness="matAutocomplete" [displayWith]="displayBusiness">
                <mat-option class="capitalize" *ngFor="let business of businesses" [value]="business"
                    (onSelectionChange)="selectBusiness(business, $event)">
                    {{ business.name }}
                </mat-option>
                <hr *ngIf="shouldInviteBusinessSuggestion() && !showBusinessSuggestionField" class="divider border-2 my-2">
                <mat-option class="bg-gray-200"
                    *ngIf="shouldInviteBusinessSuggestion() && !showBusinessSuggestionField && (searchBusinessControl.value?.name || searchBusinessControl.value)"
                    (onSelectionChange)="onBusinessSuggestOptionSelection($event)">
                    <span class="text-blue-600">
                        <span translate>lingueopro.job.form.suggestButton </span> <span class="font-semibold"> {{ (searchBusinessControl.value?.name ||
                            searchBusinessControl.value || '') }}</span>
                    </span>
                </mat-option>
            </mat-autocomplete>
        </div>

        <mat-error *ngIf="searchBusinessControl.touched && searchBusinessControl.hasError('required')" translate>
            lingueopro.job.form.errorRequired
        </mat-error>

        <div class="flex flex-col mt-2" *ngIf="suggestedBusinessControl.value || user.business_suggested">
            <div class="text-lg">
            <span translate>lingueopro.job.form.yourSuggestion.business </span> <span class="font-semibold"> {{
                suggestedBusinessControl.value || user.business_suggested }}</span>
            </div>
        </div>
    </div>
</ng-container>

<div class="w-full text-right" *ngIf="showButton">
    <button class="nextstep-btn" (click)="submit()" [disabled]="!canSubmit()">
        <span translate>
            {{ textButton }}
        </span>
    </button>
</div>